module.exports = __webpack_public_path__ + "img/20210502.1bff36cb.png";